import { useQuery } from "react-query";
import inventoryClient from "../clients/inventoryClient";

function useSpecRecipesPaginated(page, filters, disable) {
  const queryReturnValues = useQuery(
    ["spec-recipes-paginated", { page, filters }],
    inventoryClient.getSpecRecipesPaginated,
    {
      staleTime: 1000 * 60 * 10,
      keepPreviousData: true,
      enabled: disable ? false : true,
    }
  );

  return queryReturnValues;
}

export default useSpecRecipesPaginated;
